import { render, staticRenderFns } from "./EditDeliverData.vue?vue&type=template&id=13096928&scoped=true&"
import script from "./EditDeliverData.vue?vue&type=script&lang=js&"
export * from "./EditDeliverData.vue?vue&type=script&lang=js&"
import style0 from "./EditDeliverData.vue?vue&type=style&index=0&id=13096928&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13096928",
  null
  
)

export default component.exports